<script lang="ts" setup>
import { BreadcrumbsProps } from "~/components/Utils/Breadcrumbs.props"
import { ListPostsProps } from "~/components/Grid/ListPosts.props"
import { customPaths } from "~/utils/constants"
import { SeoBaseProps } from "~/components/seo/Base.props"
import { removePageFromUrl, removeParamsAndAnchors } from "~/utils/url"
import { checkPage } from "~/utils/pager"

const { t } = useI18n()
const route = useRoute()

await checkPage(route)

const posts: ListPostsProps = reactive({
  title: t("magazine.allPostsOfTopMagazine"),
  postsList: [],
  totalPosts: 0
})

const multiplySequence = (x: number) => {
  const pageBefore = x - 1
  return pageBefore * 12
}

const currentPage = computed(() =>
  route.params.page
    ? multiplySequence(parseInt(route.params.page as string))
    : 0
)

const { data: getFirstPosts, error: errorGetFirstPosts } = await useFetch(
  `/api/magazine/getPostsPagination/${currentPage.value}/12`,
  {
    method: "GET"
  }
)

if (errorGetFirstPosts.value) {
  console.warn("error get first posts", errorGetFirstPosts.value)
  await navigateTo(`${removeParamsAndAnchors(removePageFromUrl(route.path))}`, {
    redirectCode: 302
  })
} else {
  posts.postsList = getFirstPosts?.value?.posts
  posts.totalPosts = getFirstPosts?.value?.total
}

const breadcrumbs: ComputedRef<BreadcrumbsProps> = computed(() => ({
  links: [
    {
      label: "Home",
      to: "/"
    },
    {
      label: "Top Magazine",
      to: customPaths.magazineRoot
    }
  ],
  currentPage: t("magazine.breadcrumbs.AllPosts")
}))

const seoData = computed((): SeoBaseProps => {
  return {
    metaTitle: `${t("magazine.allPostsOfTopMagazine")} - Pagina ${
      route.params.page
    }`
  }
})
</script>

<template>
  <div v-if="posts.postsList && posts.postsList.length > 0">
    <SeoBase v-if="seoData" v-bind="seoData" />
    <PagesPosts
      :postsList="posts"
      :breadcrumbsLinks="breadcrumbs"
      :hasDropdownCategory="false"
    />
  </div>
</template>
